import DocumentSelector from './document-selector';

export default DocumentSelector;
